import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VScrollYTransition } from 'vuetify/lib/components/transitions';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTreeview } from 'vuetify/lib/components/VTreeview';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "n20-container role-edit-form",
    attrs: {
      "fluid": ""
    }
  }, [_c('core-prompt', {
    attrs: {
      "title": _vm.$i18n_t('Common.areYouSure'),
      "open": _vm.showDialogRoleWizardDelete,
      "value": _vm.confirmRoleWizardDeleteId,
      "color": "red",
      "buttons": [{
        text: _vm.$i18n_t('Common.cancel'),
        emit: 'cancel'
      }, {
        text: _vm.$i18n_t('Common.delete'),
        color: 'red',
        emit: 'delete'
      }]
    },
    on: {
      "close": function ($event) {
        _vm.showDialogRoleWizardDelete = false;
      },
      "delete": _vm.deleteRole
    }
  }), _c('core-header', {
    attrs: {
      "headline": _vm.$i18n_t('Common.accMgmtRoleEditorHead'),
      "subtitle": _vm.$i18n_t('Common.accMgmtRoleEditorInfo')
    }
  }), _c(VRow, {
    staticClass: "n20-mainrow",
    staticStyle: {
      "min-width": "0"
    }
  }, [_vm.tenants.length > 0 ? _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('core-n20Card', {
    attrs: {
      "title": _vm.$i18n_t('Common.accMgmtRoleEditorHead'),
      "buttons": _vm.buttons01
    },
    on: {
      "saveTab01": _vm.saveTab01,
      "closeTab01": _vm.closeTab01
    }
  }, [_c('p', {
    staticClass: "px-4 mt-4"
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('Common.accMgmtRoleEditorHeadInfo')) + "\n        ")]), _c(VCardText, [_c(VScrollYTransition, {
    attrs: {
      "mode": "out-in"
    }
  }, [_c(VTabs, {
    class: {
      sm: _vm.$vuetify.breakpoint.smAndDown
    },
    model: {
      value: _vm.tabItem,
      callback: function ($$v) {
        _vm.tabItem = $$v;
      },
      expression: "tabItem"
    }
  }, [_c(VTabsSlider, {
    attrs: {
      "color": _vm.color
    }
  }), _c(VTab, {
    attrs: {
      "href": "#tab-1"
    }
  }, [_c(VIcon, {
    staticClass: "mr-2"
  }, [_vm._v("fal fa-wand-magic")]), _vm._v("\n                " + _vm._s(_vm.$i18n_t('accMgmt.tenant.defaultRoleWizard')) + "\n              ")], 1), _c(VTab, {
    attrs: {
      "href": "#tab-2"
    }
  }, [_c(VIcon, {
    staticClass: "mr-2"
  }, [_vm._v("fal fa-user-tag")]), _vm._v("\n                " + _vm._s(_vm.$i18n_t('Common.accMgmtRoleEditorHead')) + "\n              ")], 1), _c(VTabsItems, {
    attrs: {
      "touchless": ""
    },
    model: {
      value: _vm.tabItem,
      callback: function ($$v) {
        _vm.tabItem = $$v;
      },
      expression: "tabItem"
    }
  }, [_c(VTabItem, {
    key: "1",
    attrs: {
      "value": "tab-1"
    }
  }, [_c(VCardTitle, {
    class: _vm.$vuetify.breakpoint.smAndDown ? 'px-0' : 'px-4'
  }, [_c('h3', {
    staticClass: "mt-0"
  }, [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.tenant.defaultRoleWizard')))])]), _c(VCardText, {
    class: _vm.$vuetify.breakpoint.smAndDown ? 'px-0' : 'px-4'
  }, [_c('p', {
    staticClass: "headinfo px-0"
  }, [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.tenant.defaultRoleWizardInfo')))]), _c('core-tenant-scope-access-selector-role-wizard', {
    ref: "accessSelector",
    staticClass: "pa-0",
    attrs: {
      "paddingClass": "pa-0",
      "allow-empty-role-set": "",
      "roles": _vm.rolesForScope
    },
    on: {
      "scopeChosen": _vm.fetchDefaultRolesForScope,
      "scopeRolesChosen": _vm.processDefaultRoles
    }
  })], 1)], 1), _c(VTabItem, {
    key: "2",
    attrs: {
      "value": "tab-2"
    }
  }, [_c(VCardTitle, {
    class: _vm.$vuetify.breakpoint.smAndDown ? 'px-0' : 'px-4'
  }, [_c('h3', {
    staticClass: "mt-0"
  }, [_vm._v(_vm._s(_vm.$i18n_t('Common.accMgmtRoleEditorHead')))])]), _c(VCardText, {
    class: _vm.$vuetify.breakpoint.smAndDown ? 'px-0' : 'px-4'
  }, [_c('p', {
    staticClass: "headinfo px-0"
  }, [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.tenant.accMgmtRoleEditorInfo')))]), _c(VDialog, {
    attrs: {
      "dark": _vm.UiTheme,
      "max-width": "800px",
      "persistent": ""
    },
    model: {
      value: _vm.roleAddDialog,
      callback: function ($$v) {
        _vm.roleAddDialog = $$v;
      },
      expression: "roleAddDialog"
    }
  }, [_c('core-tenant-role-edit', {
    attrs: {
      "item": _vm.roleEditItem,
      "ruleList": _vm.ruleList,
      "tenantId": _vm.selectedTenant.id
    },
    on: {
      "roleSaved": _vm.refreshRoles,
      "close": function ($event) {
        _vm.roleAddDialog = false;
      }
    }
  })], 1), _c('core-n20Card', {
    staticClass: "dt-card-text-01",
    attrs: {
      "buttons": _vm.buttonsRoleList
    },
    on: {
      "openRoleAddDialog": _vm.openRoleAddDialog
    }
  }, [_c(VCardText, {
    staticClass: "pl-0 pr-0"
  }, [_c(VStepper, {
    attrs: {
      "vertical": ""
    },
    model: {
      value: _vm.roleEditorStepIndex,
      callback: function ($$v) {
        _vm.roleEditorStepIndex = $$v;
      },
      expression: "roleEditorStepIndex"
    }
  }, [_c(VStepperStep, {
    attrs: {
      "step": "1",
      "color": _vm.color,
      "complete": _vm.roleEditorStepIndex > 1
    },
    on: {
      "click": function ($event) {
        _vm.roleEditorStepIndex = 1;
        _vm.activeTenants = [];
      }
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$i18n_t('accMgmt.tenant.tenantSelection')) + "\n                          ")]), _c(VStepperContent, {
    attrs: {
      "step": "1"
    }
  }, [_c(VCard, [_c(VTextField, {
    staticClass: "pa-2",
    attrs: {
      "label": _vm.$i18n_t('Common.search'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "append-icon": "fal fa-search",
      "clearable": "",
      "hide-details": ""
    },
    model: {
      value: _vm.treeSearch,
      callback: function ($$v) {
        _vm.treeSearch = $$v;
      },
      expression: "treeSearch"
    }
  }), _c(VTreeview, {
    staticStyle: {
      "overflow": "auto"
    },
    attrs: {
      "items": _vm.tenants,
      "active": _vm.activeTenants,
      "transition": true,
      "activatable": true,
      "hoverable": true,
      "selectable": false,
      "search": _vm.treeSearch,
      "expand-icon": "fal fa-angle-down",
      "item-text": "name"
    },
    on: {
      "update:active": [function ($event) {
        _vm.activeTenants = $event;
      }, _vm.changedSelectedTenant]
    },
    scopedSlots: _vm._u([{
      key: "prepend",
      fn: function ({
        item
      }) {
        return [_c(VIcon, {
          class: _vm.color + '--text ml-2',
          staticStyle: {
            "width": "30px"
          },
          attrs: {
            "size": "24"
          },
          domProps: {
            "textContent": _vm._s(_vm.tenantTreeIcon(item))
          }
        })];
      }
    }], null, false, 3115666739)
  })], 1)], 1), _c(VStepperStep, {
    attrs: {
      "step": "2",
      "color": _vm.color,
      "complete": _vm.roleEditorStepIndex > 2
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$i18n_t('Common.accMgmtRoleEditorHead')) + "\n                          ")]), _c(VStepperContent, {
    attrs: {
      "step": "2"
    }
  }, [_vm.selectedTenant && _vm.selectedTenant.scopeId ? _c(VCard, [_c(VCardTitle, [_c('h3', {
    staticClass: "mt-0"
  }, [_vm._v(_vm._s(_vm.selectedTenant.name))])]), _c(VCardText, {
    staticClass: "px-0"
  }, [_c(VDataTable, {
    attrs: {
      "items": _vm.roleList,
      "options": _vm.tableOptions,
      "headers": _vm.tableLocalizations.headers,
      "footer-props": _vm.tableLocalizations.tableFooterProps,
      "sort-by": _vm.tableOptions.sortBy,
      "sort-desc": _vm.tableOptions.sortDesc,
      "item-key": "id",
      "page": _vm.tableOptions.page,
      "expanded": _vm.expandedRows
    },
    on: {
      "update:options": function ($event) {
        _vm.tableOptions = $event;
      },
      "update:page": function ($event) {
        return _vm.$set(_vm.tableOptions, "page", $event);
      },
      "update:expanded": function ($event) {
        _vm.expandedRows = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (props) {
        return [_c('tr', {
          staticStyle: {
            "cursor": "pointer"
          }
        }, [_c('td', {
          on: {
            "click": function ($event) {
              return _vm.openRoleEditDialog(props.item);
            }
          }
        }, [props.item.properties && props.item.properties.icon ? _c(VIcon, {
          attrs: {
            "left": ""
          }
        }, [_vm._v("\n                                          fas\n                                          " + _vm._s(props.item.properties.icon.startsWith('fa-') ? props.item.properties.icon : 'fa-' + props.item.properties.icon) + "\n                                        ")]) : _vm._e()], 1), _c('td', {
          on: {
            "click": function ($event) {
              return _vm.openRoleEditDialog(props.item);
            }
          }
        }, [_vm._v(_vm._s(props.item.id))]), _c('td', {
          on: {
            "click": function ($event) {
              return _vm.openRoleEditDialog(props.item);
            }
          }
        }, [_vm._v(_vm._s(props.item.name))]), _c('td', {
          on: {
            "click": function ($event) {
              return _vm.openRoleEditDialog(props.item);
            }
          }
        }, [_c('div', {
          staticClass: "text-truncate",
          staticStyle: {
            "width": "200px"
          }
        }, [_vm._v("\n                                          " + _vm._s(props.item.description) + "\n                                        ")])]), _c('td', {
          on: {
            "click": function ($event) {
              return _vm.openRoleEditDialog(props.item);
            }
          }
        }, [_vm._v(_vm._s(props.item.Rules.length))]), _c('td', {
          staticClass: "text-right"
        }, [_c(VIcon, {
          attrs: {
            "color": _vm.color,
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.openRoleEditDialog(props.item);
            }
          }
        }, [_vm._v("\n                                          fal fa-edit\n                                        ")]), _vm._v("\n                                         \n                                        "), _c(VIcon, {
          attrs: {
            "color": _vm.color,
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.confirmDeleteRole(props.item.id);
            }
          }
        }, [_vm._v("\n                                          fal fa-trash-alt\n                                        ")])], 1)])];
      }
    }, {
      key: "expanded-item",
      fn: function (props) {
        return [_c('tr', [_c('td', {
          attrs: {
            "colspan": "5"
          }
        }, [_c('core-tenant-role-edit', {
          attrs: {
            "item": props.item,
            "ruleList": _vm.ruleList
          },
          on: {
            "roleSaved": _vm.refreshRoles
          }
        })], 1)])];
      }
    }, {
      key: "footer.page-text",
      fn: function (items) {
        return [_c(VRow, {
          staticClass: "text-center align-center"
        }, [_c(VCol, {
          attrs: {
            "cols": "7",
            "md": "7"
          }
        }, [_vm._v("\n                                        " + _vm._s(items.pageStart) + "-" + _vm._s(items.pageStop) + " " + _vm._s(_vm.$i18n_t('Common.of')) + "\n                                        " + _vm._s(items.itemsLength) + "\n                                      ")]), _c(VCol, {
          attrs: {
            "cols": "5",
            "md": "5"
          }
        }, [_c('niota-classic-common-table-page-selector', {
          attrs: {
            "page": _vm.tableOptions.page,
            "table-max-items": _vm.serverItemsLength,
            "table-items-per-page": _vm.tableOptions.itemsPerPage,
            "title-txt": _vm.$i18n_t('Common.goToPage')
          },
          on: {
            "page-change": function ($event) {
              return _vm.setCurrentTablePage($event);
            }
          }
        })], 1)], 1)];
      }
    }, {
      key: "no-data",
      fn: function () {
        return [_c(VAlert, {
          staticClass: "mb-1",
          attrs: {
            "value": true,
            "color": "transparent",
            "icon": "fal fa-comment-exclamation"
          }
        }, [_vm._v("\n                                      " + _vm._s(_vm.$i18n_t('Common.SorryNothingToDisplay')) + "\n                                    ")])];
      },
      proxy: true
    }], null, false, 3707902348)
  })], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };